import { render, staticRenderFns } from "./goods-form.vue?vue&type=template&id=729b111e&scoped=true&"
import script from "./goods-form.vue?vue&type=script&lang=js&"
export * from "./goods-form.vue?vue&type=script&lang=js&"
import style0 from "./goods-form.vue?vue&type=style&index=0&id=729b111e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b111e",
  null
  
)

export default component.exports